import { LOAD_PROJECTS, TOGGLE_PROJECT_FORM, CLEAR_PROJECT_FORM_ERRORS } from 'constants/ActionTypes';
import { getIntlMessage } from 'helpers/utilHelpers';
import { loadProjectsSuccess } from '../entities/projectActions';
import { getSearch, getFiltersByKey, getSortingByKey } from 'selectors/settingsSelectors';
import { PROJECT_PAGE } from 'constants/SettingConstants';

// Handles project form modal
export const toggleProjectForm = (projectId = null, errors) => {
  return {
    type: TOGGLE_PROJECT_FORM,
    projectId,
    errors,
  };
};

// Clear errors in project form modal
export const clearProjectFormErrors = () => {
  return {
    type: CLEAR_PROJECT_FORM_ERRORS,
  };
};

// Loads projects with expanded fields which needs on the projects page
export const loadListProjects = (payload) => {
  return {
    type: LOAD_PROJECTS,
    payload: {
      extraFields: ['client', 'services', 'clientProfiles'],
      resource: 'projects',
      onSuccess: (projects) => loadProjectsSuccess(projects, true),
      onErrorMessage: getIntlMessage('project.load.error'),
      filters: {
        search: {
          selector: getSearch,
        },
        hasManager: {
          selector: (state) => getFiltersByKey(state, { settingKey: PROJECT_PAGE }),
          key: 'manager',
          skipValue: 'all',
        },
        hasLeader: {
          selector: (state) => getFiltersByKey(state, { settingKey: PROJECT_PAGE }),
          key: 'leader',
          skipValue: 'all',
        },
        hasResponsible: {
          selector: (state) => getFiltersByKey(state, { settingKey: PROJECT_PAGE }),
          key: 'responsible',
          skipValue: 'all',
        },
        hasService: {
          selector: (state) => getFiltersByKey(state, { settingKey: PROJECT_PAGE }),
          key: 'services',
          skipValue: 'all',
        },
        status: {
          selector: (state) => getFiltersByKey(state, { settingKey: PROJECT_PAGE }),
          key: 'status',
          skipValue: 'all',
        },
      },
      sort: (state) => getSortingByKey(state, { settingKey: PROJECT_PAGE }),
      ...payload,
    },
  };
};
